import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import sslIco from '../../img/ssl.png'
import './VerifySSNUser.css';
import GlobalStore from "../../store/GlobalStore";
import ApiConnector from "../api/ApiConnector";
import 'react-notifications/lib/notifications.css';
import ReactQueryParams from 'react-query-params';
import TagManager from 'react-gtm-module';
import { config } from '../../config.js';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

const fbPixelOptions = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
};

ReactPixel.init('615166872018376', null, fbPixelOptions);
ReactGA.initialize('UA-91391382-1');


class VerifySSNUser extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.validationUserShortData = this.validationUserShortData.bind(this);
        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.state = {
            isUserShortData: false,
            userShortData: null,
            callbackGetUserBySSNStatus: null,
            nameError: false,
            SSNError: false,
            loader: false,
            isAnalyticsEventFiredOnce: false,
        }

        ReactGA.ga((tracker) => {
            this.analyticsClientID = tracker.get('clientId');
            console.log('client ID: ' + this.analyticsClientID);
        });
    }

    componentDidMount() {
        const tagManagerArgsResultConfirmPage = {
            gtmId: 'GTM-5MHWB3M',
            dataLayer: {
                event: 'elementHover',
                eventCategory: 'appointment timeslot selected',
                eventAction: this.analyticsClientID,
                eventLabel: "slot slctd" +  new Date().toString()
                + " " + GlobalStore.getInstance().data['categoryName']
                + ",_, " + GlobalStore.getInstance().data['stepTimeData']["activeDoctorName"]
                + " " + GlobalStore.getInstance().data['stepTimeData']["StartTime"],
                eventValue: '',
            }
        };

        if (this.queryParams.env !== "test" && config.environment === "prod" && !this.state.isAnalyticsEventFiredOnce) {
            this.setState({
                isAnalyticsEventFiredOnce: true
            });
            console.log("booking confirmation page was achieved");
            TagManager.initialize(tagManagerArgsResultConfirmPage);
            ReactPixel.track(
                'InitiateCheckout',
                {
                    content_name: "slot slctd" +  new Date().toString()
                    + " " + GlobalStore.getInstance().data['categoryName']
                    + ",_, " + GlobalStore.getInstance().data['stepTimeData']["activeDoctorName"]
                    + " " + GlobalStore.getInstance().data['stepTimeData']["StartTime"],
                    content_category: 'appointment timeslot selected',
                    value: 0.05,
                    currency: 'USD',
                    referrer: document.referrer,
                    userAgent: navigator.userAgent,
                    language: navigator.language
                });
        }
    }

    validationUserShortData() {
        let userShortData = {
            userName: this.refs.personalName.value,
            userSurname: this.refs.personalSurname.value,
            personalPhone: this.refs.personalPhone.value,
            userSSN: this.refs.personalSSN.inputElement.value.replace(/[_]/g, '')
        };

        if (userShortData.userName !== "" && userShortData.userSurname !== "" && userShortData.personalPhone !== "" && userShortData.userSSN.length === 11) {
            this.setState({
                isUserShortData : true,
                userShortData: userShortData
            });
            GlobalStore.getInstance().data['userShortData'] = userShortData;
        }else {
            this.setState({
                isUserShortData : false,
                userShortData: null
            });
        }

    }

    saveAndContinue() {
        this.setState({ loader : true });
        let userShortData = this.state.userShortData;


        //this getUserBySSN request is now actually a canBook request. it'll most likely return 200,
        //even if the user is new, therefore here we need to register a user if it's new
        let getUserBySSN = ApiConnector.getUserBySSN(userShortData.userName, userShortData.userSurname, userShortData.userSSN, userShortData.personalPhone);
        // console.log(getUserBySSN);
        // console.log(getUserBySSN.status);
        getUserBySSN.then((response => {
            this.setState({callbackGetUserBySSNStatus: response.status}, () => {
                switch (this.state.callbackGetUserBySSNStatus) {
                    case 400: {
                        this.setState({ nameError : true, SSNError : false, loader : false });
                        NotificationManager.error('SSN is found, but Name and/or Surname don\'t match the SSN. Please retry.', 'Not found', 5000);
                        /**
                         * Log in Analytics that user with new SSN was registered
                         */
                        let tagManagerArgsUniversal = {
                            gtmId: 'GTM-5MHWB3M',
                            dataLayer: {
                                event: 'elementHover',
                                eventCategory: 'appointment SSN entered with error - user/ssn data doesn\'t match',
                                eventAction: this.analyticsClientID,
                                eventLabel: new Date().toString()
                            }
                        };
                        if (this.queryParams.env !== "test" && config.environment === "prod") {
                            TagManager.initialize(tagManagerArgsUniversal);
                            console.log("SSN entered with error event was sent to analytics");
                            ReactPixel.track(
                                'AddPaymentInfo',
                                {
                                    content_category: 'appointment SSN entered with error - user/ssn data doesn\'t match',
                                    value: 0.05,
                                    currency: 'USD',
                                    referrer: document.referrer,
                                    userAgent: navigator.userAgent,
                                    language: navigator.language
                                });
                        }
                        break;
                    }
                    case 404: {
                        //Якщо такого користувача у базі немає, пробуємо його реєструвати
                        let userShortData = this.state.userShortData;
                        let getUserAfterRegistration = ApiConnector.registrationUserBySSN(userShortData.userName, userShortData.userSurname, userShortData.personalPhone, userShortData.userSSN);

                        getUserAfterRegistration.then(response => {
                            switch (response.status) {
                                case 400: {
                                    this.setState({ nameError : false, SSNError : true, loader : false });
                                    console.log(this.state.nameError);
                                    NotificationManager.error('You entered an invalid SSN number, check it and try again', 'Not valid SSN', 5000);
                                    break;
                                }
                                case 201: {
                                    // успішно зареєстрованно
                                    response.json().then(resultObject => {
                                        GlobalStore.getInstance().data['userFullData'] = resultObject;
                                    });
                                    GlobalStore.getInstance().data['ifNewUser'] = true;

                                    /**
                                     * Log in Analytics that user with new SSN was registered
                                     */
                                    let tagManagerArgsUniversal = {
                                        gtmId: 'GTM-5MHWB3M',
                                        dataLayer: {
                                            event: 'elementHover',
                                            eventCategory: 'appointment SSN entered - new user created',
                                            eventAction: this.analyticsClientID,
                                            eventLabel: new Date().toString()
                                        }
                                    };
                                    if (this.queryParams.env !== "test" && config.environment === "prod") {
                                        TagManager.initialize(tagManagerArgsUniversal);
                                        ReactPixel.track(
                                            'AddPaymentInfo',
                                            {
                                                content_category: 'appointment SSN entered - new user created',
                                                value: 10,
                                                currency: 'USD',
                                                referrer: document.referrer,
                                                userAgent: navigator.userAgent,
                                                language: navigator.language
                                            });
                                    }

                                    this.props.nextStep();
                                    break;
                                }
                            }
                        });
                        break;
                    }
                    case 200: {
                        //this means in new API such user can book
                        GlobalStore.getInstance().data['userShortData'] = userShortData;
                        // response.json().then(resultObject => {
                        //     GlobalStore.getInstance().data['userFullData'] = resultObject;
                        // });
                        // GlobalStore.getInstance().data['ifNewUser'] = false;
                        /**
                         * Log in Analytics that user with new SSN was registered
                         */
                        // let tagManagerArgsUniversal = {
                        //     gtmId: 'GTM-5MHWB3M',
                        //     dataLayer: {
                        //         event: 'elementHover',
                        //         eventCategory: 'appointment SSN entered - existing user identified',
                        //         eventAction: this.analyticsClientID,
                        //         eventLabel: new Date().toString()
                        //     }
                        // };

                        // if (this.queryParams.env !== "test" && config.environment === "prod") {
                        //     TagManager.initialize(tagManagerArgsUniversal);
                        //     ReactPixel.track(
                        //         'AddPaymentInfo',
                        //         {
                        //             content_category: 'appointment SSN entered - existing user identified',
                        //             value: 10,
                        //             currency: 'USD',
                        //             referrer: document.referrer,
                        //             userAgent: navigator.userAgent,
                        //             language: navigator.language
                        //         });
                        // }

                        this.props.nextStep();
                        break;
                    }
                }
            });
        })).catch(() => {
            this.setState({ loader: false });
            NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                this.saveAndContinue();
            });
        });


    }

    generateActiveDayString(currentDate) {
        let currentDay = currentDate.getDate();
        let currentMonth = currentDate.getMonth() + 1;
        let currentYear = currentDate.getFullYear();

        if(currentDay < 10){
            currentDay = '0' + currentDay;
        }
        if(currentMonth < 10){
            currentMonth = '0' + currentMonth;
        }

        return currentDay + '.' + currentMonth + '.' + currentYear;
    }

    render() {
        // console.log(GlobalStore.getInstance()._data);
        let userShortData = GlobalStore.getInstance().data['userShortData'];
        let dataFromGlobalStore = GlobalStore.getInstance().data;

        if(GlobalStore.getInstance().data['office']=='all') {
            let office = GlobalStore.getInstance().data['officesList'][GlobalStore.getInstance().data['stepTimeData']['BranchId']];
            GlobalStore.getInstance().data['office'] = office.Id;
            GlobalStore.getInstance().data['officeName'] = office.Name;
            GlobalStore.getInstance().data['officeAddress'] = [office.Address.Street,office.Address.PostalCode,office.Address.City,office.Address.Country].join(', ')+'.';
        }

        return (
            <div>
                {(this.state.loader === true) ? <div className="globalLoader loaderNotFirstStep"><div className="globalSpinner"></div></div> : ''}

                <div className="col-xs-12 col-md-4 col-md-push-8">
                    <div className="reservationInformationBlock">
                        <div className="resInfHeader">Ajanvaraustiedot:</div>

                        <ul>
                            <li><span className="resInfTitle">Erikoisala:</span><span className="resInfName">{dataFromGlobalStore.categoryName}</span></li>
                            <li><span className="resInfTitle">Toimipiste:</span><span className="resInfName">{dataFromGlobalStore.officeName}<span className="resInfName-address">{dataFromGlobalStore.officeAddress}</span></span></li>
                            <li><span className="resInfTitle">Hammaslääkäri:</span><span className="resInfName">{dataFromGlobalStore.stepTimeData.activeDoctorName}</span></li>
                            <li><span className="resInfTitle">Päivämäärä/Kellonaika:</span><span className="resInfName">{dataFromGlobalStore.stepTimeData.activeDayName + ', '
                            + this.generateActiveDayString(new Date(dataFromGlobalStore.stepTimeData.currentFreeTimeString))
                            + ', ' + dataFromGlobalStore.stepTimeData.activeFreeTime}</span></li>
                            <li><span className="resInfTitle">Kesto:</span><span className="resInfName">{dataFromGlobalStore.stepTimeData.activeLength} min</span></li>
                        </ul>
                    </div>
                </div>
                <div className="col-xs-12 col-md-8 col-md-pull-4">
                    <div className="stepPersonalData">
                        <div className="stepPersonalDataTitle">Täytä henkilötietosi</div>
                        <div className="col-xs-6 stepPersonalDataLeftPart">
                            <div><label>Etunimi:</label></div>
                            <div className={(this.state.nameError === true) ? "inputBlock inputErrorBlock" : "inputBlock"}><input placeholder="esim. Mette" defaultValue={(userShortData !== undefined) ? userShortData.userName : ''} ref="personalName" onChange={this.validationUserShortData}/></div>
                        </div>
                        <div className="col-xs-6 stepPersonalDataRightPart">
                            <div><label>Sukunimi:</label></div>
                            <div className={(this.state.nameError === true) ? "inputBlock inputErrorBlock" : "inputBlock"}><input placeholder="esim. Meikäläinen" defaultValue={(userShortData !== undefined) ? userShortData.userSurname : ''} ref="personalSurname" onChange={this.validationUserShortData}/></div>
                        </div>
                        <div className="col-xs-6 stepPersonalDataLeftPart marginTop fullWidthBlock">
                            <div><label>Puhelinnumero:</label></div>
                            <div className="inputBlock"><input placeholder="esim. 050 123 1234" defaultValue={(userShortData !== undefined) ? userShortData.personalPhone : ''} type="tel" ref="personalPhone"  onChange={this.validationUserShortData}/></div>
                        </div>
                        <div className="col-xs-6 stepPersonalDataRightPart marginTop fullWidthBlock ssnBlock">
                            <div><label>Henkilötunnus:</label></div>
                            <div className={(this.state.SSNError === true) ? "inputBlock inputErrorBlock" : "inputBlock"}>
                                <MaskedInput
                                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[-a-zA-Z]/, /\d/, /\d/, /\d/, /[0-9a-zA-Z]/]}
                                    placeholder="PPKKVV-000X"
                                    ref="personalSSN"
                                    onChange={this.validationUserShortData}
                                    onClick={this.validationUserShortData}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 stepPersonalDataSSLInfo">
                            <img src={sslIco} /><span>Assisdent (Entteri Oy) potilastietojärjestelmä käsittelee ja säilöö potilastiedot. HammasOskari Oy ei kerää tai säilö sivuilla täytettyjä potilastietoja tai ajanvarauksia muualle. </span>
                        </div>
                    </div>
                </div>

                <div className="dataFormNavigation ssnButtonContinuePart col-xs-12">
                    <div className="col-xs-6 dataFormNavigationLeftPart"><div className="ssnButton ssnButtonBack" onClick={this.props.previousStep}>Takaisin</div></div>
                    <div className="col-xs-6 dataFormNavigationRightPart">{this.state.isUserShortData === true ? <div className="continueButton ssnButton" onClick={this.saveAndContinue}>Jatka</div> : <div className="continueButton ssnButton noActiveButton">Jatka</div>}</div>
                </div>

                <NotificationContainer/>

            </div>
        );
    }
}

export default VerifySSNUser;



// WEBPACK FOOTER //
// ./src/components/Step_4/VerifySSNUser.jsx